import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { Search } from '@mui/icons-material';
import { getData } from "../../../../services/library";

const SucursalAutocomplete = ({ value, onChange, disabled = false, size = 'small' }) => {
  const [sucursales, setSucursales] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const obtenerSucursales = () => {
    setLoading(true);
    getData("/sucursales/envasado_sucauth/" + localStorage.getItem("suc_auth"), setSucursales)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    obtenerSucursales();
  }, []);

  const filterOptions = (searchValue) => {
    if (!searchValue) return sucursales;
    return sucursales.filter(sucursal =>
      sucursal.nombre.toLowerCase().includes(searchValue.toLowerCase())
    );
  };

  const selectedSucursal = value || null;

  return (
    <Autocomplete
      value={selectedSucursal}
      onChange={(event, newValue) => {
        onChange(newValue);
        // Actualizar inputValue para que muestre el nombre seleccionado
        if (newValue) {
          setInputValue(newValue.nombre);
        } else {
          setInputValue('');
        }
      }}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      options={filterOptions(inputValue)}
      loading={loading}
      disabled={disabled}
      getOptionLabel={(option) => option?.nombre || ''}
      isOptionEqualToValue={(option, selected) => {
        if (!option || !selected) return false;
        return option.id === selected.id;
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Buscar sucursal..."
          variant="outlined"
          size={size}
          InputProps={{
            ...params.InputProps,
            startAdornment: <Search sx={{ color: 'action.active', mr: 0.5, fontSize: 18 }} />,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={16} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          sx={{
            '& .MuiInputBase-input': { 
              fontSize: '0.8rem',
              py: 0.75
            }
          }}
        />
      )}
      renderOption={(props, option) => (
        <li {...props}>
          <div>
            <div style={{ fontWeight: 600, fontSize: '0.85rem' }}>
              {option.nombre}
            </div>
            <div style={{ fontSize: '0.7rem', color: 'gray' }}>
              ID: {option.id} {option.mp_store_id && `· MP Store: ${option.mp_store_id}`}
            </div>
          </div>
        </li>
      )}
      noOptionsText="No se encontraron sucursales"
      loadingText="Cargando..."
    />
  );
};

export default SucursalAutocomplete;